import { ConcordiaNav } from '@maxpreps/apiserviceclients/apiModels';
import { createContext, useContext, useState } from 'react';
import { SITE_NAV_MODE } from './SiteNavUtils';

interface ISiteNavContext {
  activeNavId?: string;
  setActiveNavId: (string) => void;
  clearActiveNavId: () => void;
  navMode: number;
  setNavMode: (number) => void;
  siteNavData: ConcordiaNav;
}

const SiteNavContext = createContext<ISiteNavContext>({
  activeNavId: undefined,
  setActiveNavId: () => undefined,
  clearActiveNavId: () => undefined,
  navMode: SITE_NAV_MODE.None,
  setNavMode: () => undefined,
  siteNavData: undefined as any
});

const SiteNavContextProvider = ({ siteNavData, children }) => {
  const [navMode, setNavMode] = useState(SITE_NAV_MODE.None);
  const [activeNavId, setActiveNavId] = useState();
  const clearActiveNavId = () => setActiveNavId(undefined);

  const siteNavContextValue = {
    // Currently hovered item
    activeNavId,
    setActiveNavId,
    clearActiveNavId,
    // Currently active nav mode
    navMode,
    setNavMode,
    // Raw menu data
    siteNavData
  };
  return (
    <SiteNavContext.Provider value={siteNavContextValue}>
      {children}
    </SiteNavContext.Provider>
  );
};

const useSiteNavContext = () => useContext(SiteNavContext);

export { SiteNavContextProvider, useSiteNavContext as default };
